import { faPaperPlane } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Card, Textarea } from '@mantine/core';

import classes from './ChatFooter.module.css';

export interface ChatFooterProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function ChatFooter({
  value,
  onChange,
  onSend,
  onKeyPress,
  disabled = false,
  placeholder = 'Type your message here...',
}: ChatFooterProps) {
  return (
    <Card.Section withBorder p="md" pos="relative">
      <Textarea
        placeholder={placeholder}
        autosize
        minRows={2}
        className={classes.chatFooterTextarea}
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        onKeyDown={onKeyPress}
        disabled={disabled}
      />
      <ActionIcon
        variant="light"
        radius="sm"
        className={classes.submitButton}
        onClick={onSend}
        disabled={disabled || !value.trim()}
      >
        <FontAwesomeIcon icon={faPaperPlane} size="sm" />
      </ActionIcon>
    </Card.Section>
  );
}
